module.exports = __webpack_public_path__ + "static/media/Nov_2025_1.56e0b805.webp";